<template>
  <file-names-list
    v-if="selectedCustomer.id"
    :tier="tierType"
    :id="selectedCustomer.id"
  />
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import FileNamesList from "@/views/Common/AttachmentFilters/FileName.vue";

import { TIER } from "@/constants";

export default {
  name: "FileNames",
  components: {
    FileNamesList,
  },
  data() {
    return {
      tierType: TIER.domainGroups,
    };
  },
  computed: {
    ...mapGetters("authentication", ["selectedCustomer"]),
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
  },
  created() {
    this.setPageTitle(this.$t("Attachments"));
    this.setPageSubtitle([]);
  },
};
</script>
